module.exports = __webpack_public_path__ + "static/IMG_2615-af8ea75d66ebe3964270e52b256f7997.jpg";